// Desktop sidebar navigation. Hidden on mobile (lg+ only) — mobile uses
// BottomNav + TopBar instead.
//
// Phase 81: removed the bottom theme toggle button. The Settings > 外觀
// section already provides light/dark switching, so the sidebar copy was
// a duplicate affordance. Kept the version label.
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useI18n } from '../i18n/index.jsx';
import { APP_VERSION } from '../lib/version.js';

const items = [
  { to: '/',             labelKey: 'nav.dashboard',  icon: '🏠' },
  { to: '/transactions', labelKey: 'nav.transactions', icon: '📋' },
  { to: '/add',          labelKey: 'add.newTitle',   icon: '➕' },
  { to: '/budgets',      labelKey: 'nav.budgets',    icon: '💳' },
  { to: '/settings',     labelKey: 'nav.settings',   icon: '⚙️' },
];

export default function Sidebar() {
  const { t } = useI18n();
  return (
    <aside
      className="hidden lg:flex flex-col w-56 shrink-0 bg-white dark:bg-slate-800 border-r border-slate-200 dark:border-slate-700 sticky top-12 self-start"
      style={{ height: 'calc(100vh - 3rem)' }}
      aria-label={t('sidebar.aria')}
    >
      <nav className="flex-1 px-3 py-4 overflow-y-auto">
        <ul className="space-y-1">
          {items.map(({ to, labelKey, icon }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={to === '/'}
                className={({ isActive }) => [
                  'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium min-h-[44px]',
                  isActive
                    ? 'bg-brand-50 dark:bg-brand-900/40 text-brand-700 dark:text-brand-300'
                    : 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700',
                ].join(' ')}
              >
                <span className="text-base w-5 text-center" aria-hidden="true">{icon}</span>
                <span>{t(labelKey)}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <div className="px-3 py-3 border-t border-slate-200 dark:border-slate-700">
        <p className="px-3 text-xs text-slate-400 dark:text-slate-500">
          Finance · v{APP_VERSION}
        </p>
      </div>
    </aside>
  );
}
